module.exports = __webpack_public_path__ + "static/hakam-b4ac5692e37e316c2da893a4babafbf8.jpg";